import * as getters from './getters';
import * as actions from './actions';
import mutations from './mutations';

let state = {
  isDesktop: false,
  menu: null,
};

export default {
  state,
  getters,
  actions,
  mutations,
};
